export const config = {
    dateFormat: 'DD.MM.YYYY',
    dateTimeFormat: 'DD.MM.YYYY HH:mm',
    errorStatusesMessages: {
        401: "Вам необходимо авторизоваться",
        403: "Вы не имеете прав на доступ к данной странице",
        404: "Страница не найдена или не существует",
    }
};
